import axios, { AxiosInstance, CreateAxiosDefaults } from 'axios';
import { fetchAuthSessionDedupe } from '../utils/auth';
import { INTERNAL_API_URL, BACKEND_API_URL } from '../config';
// ----------------------------------------------------------------------
let internalApiInstance: AxiosInstance | null = null;
let backendApiInstance: AxiosInstance | null = null;

export async function getAuthToken(): Promise<string> {

  // const Authorization = `Bearer ${(await Auth.fetchAuthSession()).tokens?.idToken}`;
  const idToken = (await fetchAuthSessionDedupe())?.tokens?.idToken?.toString();

  if (!idToken) {
    throw new Error("Failed to fetch ID token");
  }

  return `Bearer ${idToken}`;
}

/**
 * Initialize Axios instance (called only once)
 */
async function initializeInternalApiInstance(
  config?: CreateAxiosDefaults
): Promise<AxiosInstance> {
  return axios.create({
    baseURL: INTERNAL_API_URL,
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
    ...config,
  });
}

async function initializeBackendApiInstance(
  config?: CreateAxiosDefaults
): Promise<AxiosInstance> {
  return axios.create({
    baseURL: INTERNAL_API_URL,
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
    ...config,
  });
}

export const getInternalApiInstance = async (): Promise<AxiosInstance> => {
  if (!internalApiInstance) {
    internalApiInstance = await initializeInternalApiInstance({
      baseURL: INTERNAL_API_URL,
    });
  }

  try {
    const token = await getAuthToken();
    internalApiInstance.defaults.headers.common["Authorization"] = token;
  } catch (error) {
    delete internalApiInstance.defaults.headers.common["Authorization"];
  }

  return internalApiInstance;
}

export const getBackendApiInstance = async (): Promise<AxiosInstance> => {
  if (!backendApiInstance) {
    backendApiInstance = await initializeBackendApiInstance({
      baseURL: BACKEND_API_URL,
    });
  }

  try {
    const token = await getAuthToken();
    backendApiInstance.defaults.headers.common["Authorization"] = token;
  } catch (error) {
    delete backendApiInstance.defaults.headers.common["Authorization"];
  }

  return backendApiInstance;
}